import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../constants/apiConstants';

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE_URL, // Replace with your base URL
        prepareHeaders: (headers) => {
            headers.set('Authorization', `Bearer ${localStorage.getItem('authToken')}`);
            return headers;
        },
    }),
    tagTypes: ['Submitters'], // Tags for invalidating queries
    endpoints: () => ({}), // Will be extended in specific API files
});

export default baseApi;
    